<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'
import type { Testable } from '../../../main'
import { headerVariants, type TableHeaderVariants } from '.'

export interface TableCellProperties extends Testable {
  class?: HTMLAttributes['class']
  align?: TableHeaderVariants['align']
  width?: string | undefined
  truncate?: boolean
}

const properties = withDefaults(defineProps<TableCellProperties>(), {
  class: undefined,
  align: 'start',
  width: undefined,
  truncate: false,
})
</script>

<template>
  <td
    :class="cn('atabix-table-cell', headerVariants({ align: properties.align }), { truncate: truncate, 'text-wrap': !truncate }, properties.class)"
    :data-test
    :style="{ width }"
  >
    <slot />
  </td>
</template>

<style lang="scss">
.atabix-table-cell {
  @apply p-4 align-middle;
}
</style>
